import { BRANDING_TEMPLATES_FILTER_URL } from 'constants/ApiConstants';
import type { ApiError, MetaAction, PageContent } from 'modules/global/generic.types';

import * as types from './actionTypes';
import type * as ActionType from './types';

export const fetchBrandingTemplatesRequest = (
  params: ActionType.FetchBrandingTemplatesParams,
  meta: MetaAction = {}
): ActionType.FetchBrandingTemplatesRequestAction => ({
  type: types.FETCH_BRANDING_TEMPLATES_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: BRANDING_TEMPLATES_FILTER_URL,
      params,
    },
  },
  meta,
});

export const fetchBrandingTemplatesSuccess = (
  brandingTemplates: PageContent<ActionType.BrandingTemplate>,
  meta: MetaAction = {}
): ActionType.FetchBrandingTemplatesSuccessAction => ({
  type: types.FETCH_BRANDING_TEMPLATES_SUCCESS,
  payload: brandingTemplates,
  meta,
});

export const fetchBrandingTemplatesFailure = (
  error: ApiError,
  meta: MetaAction = {}
): ActionType.FetchBrandingTemplatesFailureAction => ({
  type: types.FETCH_BRANDING_TEMPLATES_FAILURE,
  payload: error,
  error: true,
  meta,
});
